<template>
  <commona :data="config"></commona>
</template>
<script>
import commona from "./commona.vue";
export default {
  components: { commona },
  data() {
    return {
      config: {
        title: '其他费用',
        urlKey: '/pay',
        formId: 'qita',
        item: {
          carId: 0,
          carNo: "",
          payCost: 0,
          payDate: Date.now(),
          cardNo: "",
          mileage: 0,
          proofList: [],
          payStation: "",
          payVolume: 0,
          remainVolume: 0,
          remark: "",
          type: "",
          unitPrice: 0,
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pay/otherPay.vue